export default "__VITE_ASSET__BZxcmzAh__"